export default "__VITE_ASSET__66840366__"